import { useEffect, useRef, useState } from 'react';

export function useBottomButtonVisibility(ref) {
  const [visible, setVisible] = useState(false);
  const lastY = useRef(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const onScroll = () => {
      const y = el.scrollTop;
      const maxY = el.scrollHeight - el.clientHeight;
      const scrollingDown = y > lastY.current;

      if (y < 50) {
        setVisible(false);
      } else if (y >= maxY - 5) {
        setVisible(true);
      } else if (scrollingDown) {
        setVisible(true);
      } else {
        setVisible(false);
      }

      lastY.current = y;
    };

    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [ref]);

  return visible;
}
